import { PageState } from 'src/app/core/base-page';
import { Entity } from 'src/app/core/data/schema/entity';
import { Dictionary } from 'src/app/core/helper/util';

export class TicketBook extends Entity {

    static className = 'TicketBook';
    static idField = 'ticketBookId';
    static controller = 'ticketbooks';
    static ticketBooksForRaffle: Dictionary<TicketBook[]> = {};

    ticketBookId = 0;
    raffleId: number;
    startTicketNumber: number;
    qty: number;
    dateCreated: string;
    status: TicketBookStatus | null;
    modifiedBy: number | null;
    dateModified: string;

    public constructor(init?: Partial<TicketBook>) {
        super(TicketBook.className, TicketBook.idField, TicketBook.controller);
        Object.assign(this, init);
    }

    static async fetchForRaffle(raffleId: number) {
        if (this.ticketBooksForRaffle[raffleId] == null) {
            this.ticketBooksForRaffle[raffleId] = await this.fetchArray(this, this.controller, `forraffle/${raffleId}`);
        }
        return this.ticketBooksForRaffle[raffleId];
    }

    override async save(busyState?: PageState, controller?: string | undefined, endpoint?: string, hideLoad?: boolean) {
        const isNew = !(this.ticketBookId > 0);
        const didSave = await super.save(busyState, controller, endpoint, hideLoad);
        if (!didSave) {
            return false;
        }

        // ensure the ticket book is in the cache
        if (isNew) {
            TicketBook.ticketBooksForRaffle[this.raffleId].push(this);
        } else {
            const index = TicketBook.ticketBooksForRaffle[this.raffleId].findIndex(m => m.ticketBookId === this.ticketBookId);
            if (index >= 0) {
                TicketBook.ticketBooksForRaffle[this.raffleId][index] = this;
            }
        }

        return didSave;
    }
}

export enum TicketBookStatus {
    Enabled = 1,
    Exhausted = 2,
    Void = 3
}
